
import { CourseCards } from './CourseCards'

export const Courses = () => {
    return (
        <CourseCards />
    )
}